export default class CouldNotDeleteMediaError extends Error {}
